import React from 'react';
import 'remixicon/fonts/remixicon.css'
import FaveHeart from "../../Components/FaveHeart";
import truncateWords from "../../../HooksHelpers/truncateWords";
import stripHtml from "../../Components/StripHTML";
import {useDispatch} from "react-redux";
import {setLearnOffCanvasIsActive, setReadOffCanvasIsActive, setWatchOffCanvasIsActive} from "../../../Features/Misc/navBarSlice";
import {setActiveLearn, setActiveRead, setActiveWatch} from "../../../Features/Misc/activeSlice";

import defaultSleepImage1 from '../../../assets/default-images/default-sleep-image-1.png';
import defaultSleepImage2 from '../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from '../../../assets/default-images/default-sleep-image-6.jpg';
import defaultSleepImage7 from '../../../assets/default-images/default-sleep-image-7.jpg';
import defaultSleepImage8 from '../../../assets/default-images/default-sleep-image-8.jpg';
import defaultSleepImage9 from '../../../assets/default-images/default-sleep-image-9.jpg';
import defaultSleepImage10 from '../../../assets/default-images/default-sleep-image-10.jpg';



export default function NewCard({
    imgSrc,
    favourite,
    text,
    title,
    type,
    date,
    authorName,
    vidLink,
    mediaId,
    mediaType,
    orientation
}) {


    const dispatch = useDispatch();

    const iconId = mediaType === "videos" ? "ri-video-line" : mediaType === "post" ? "ri-book-read-line" : "ri-book-read-line";
    const iconColour = mediaType === "tutorials" ? "text-white" : "text-purple-slumber";
    const iconBarColour = mediaType === "videos" ? "bg-pink-icon" : mediaType === "tutorials" ? "bg-gold-accent" : "bg-white";
    const textColour = mediaType === "tutorials" ? "text-black" : "text-white";
    const contentColour = mediaType === "tutorials" ? "bg-white" : "bg-dark-pink";
    const newCardType = mediaType === "videos" ? "NewWatch" : mediaType === "post" ? "NewRead" : "NewLearn";


    const payload = React.useMemo(() => {
        switch(mediaType) {
            case "videos":
                return { imgSrc, title, text, vidLink, mediaId, mediaType, orientation };

            case "post":
                return { imgSrc, title, text, authorName, date, mediaId, mediaType, orientation };

            case "tutorials":
                return { imgSrc, title, text, vidLink, mediaId, mediaType, orientation };

            default:
                return {};
        }
    }, [imgSrc, title, text, vidLink, authorName, date, mediaId, mediaType, orientation]);



    const handleOnClick = React.useCallback(() => {
        switch (type) {
            case "post":
                dispatch(setReadOffCanvasIsActive());
                dispatch(setActiveRead(payload));
                break;
            case "videos":
                dispatch(setWatchOffCanvasIsActive());
                dispatch(setActiveWatch(payload));
                break;
            case "tutorials":
                dispatch(setLearnOffCanvasIsActive());
                dispatch(setActiveLearn(payload));
                break;
            default:
                // Handle any other cases or do nothing
                break;
        }
    }, [dispatch, type, payload]);


    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10,
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);

    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];

    const remixIconCode = mediaType && mediaType === "videos" ? "ri-video-line" : mediaType === "post" ? "ri-article-line" : "ri-lightbulb-flash-line";


    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';

    return (
        <div className='newCard w-full h-116 pb-4 pl-6 pr-8 cursor-pointer hover:opacity-60 transition-opacity duration-300' onClick={handleOnClick} >
            <div className="newCard__inner grid w-full h-full grid-cols-24 grid-rows-24 rounded-lg cursor-pointer ">

                <div className={`newCard__inner__image col-start-1 col-end-25 row-start-1 row-end-11 bg-cover no-repeat bg-center rounded-t-lg cursor-pointer `} style={{backgroundImage: `url(${imageUrl})` }}>

                </div>

                <div className={`newCard__inner__iconBar col-start-1 col-end-25 row-start-11 row-end-13 ${iconBarColour} flex items-center gap-2  ${iconColour} pl-4 -mt-1 rounded-t-md cursor-pointer`}>
                    <i className={` flex items-center text-2xl font-medium  ${iconId}`} />
                    <p className={` flex items-center text-lg font-semibold  `}>{mediaType === "post"? "Read" : ""}{mediaType === "videos"? "Watch" : ""}{mediaType === "tutorials"? "Learn" : ""}</p>
                </div>

                <div className={`newCard__inner__content col-start-1 col-end-25 row-start-13 row-end-25 grid grid-cols-24 grid-rows-24 rounded-b-lg -mt-1 rounded-t-md ${contentColour} `}>

                    <FaveHeart mediaId={mediaId} mediaType={mediaType} type={newCardType}  customStyles={`row-start-2 row-end-4 col-start-19 col-end-20   xl:col-start-21 xl:col-end-22 text-2xl text-pink-icon  px-4 cursor-pointer`}/>

                    <p className={`newCard__inner__content__title row-start-6 row-end-8 col-start-1 col-end-25 ${textColour} font-semibold text-sm xl:text-base  px-4`}>{title && stripHtml(truncateWords(title, 7)) + "..."}</p>
                    <p className={`newCard__inner__content__text row-start-10 row-end-19 col-start-1 col-end-25 ${textColour} text-xs xl:text-sm px-4 `}> {text && stripHtml(truncateWords(text, 20)) + "..."} {favourite}</p>

                    {(mediaType === "post" || mediaType === "videos") &&
                        <div className={`newCard__inner__content__bottomRow row-start-19 row-end-23 col-start-1 col-end-25  flex items-center justify-between px-4`}>
                            <div className="newCard__inner__content__bottomRow__AvatarBlock flex items-center gap-2">
                                <i className={`${remixIconCode} text-2xl text-gold-accent`} ></i>
                                <div className="newCard__inner__content__bottomRow__AvatarBlock__details flex flex-col py-1">

                                    <div className={` ${textColour} text-xs font-semibold`}>{displayName}</div>
                                    <div className={` ${textColour} text-xxs`}>{date.substring(0, 10)}</div>
                                </div>
                            </div>

                                <i
                                    className={`ri-arrow-right-line text-2xl text-gold-accent cursor-pointer `}
                                    onClick={handleOnClick}
                                />

                        </div>
                    }


                    {mediaType === "tutorials" && <>
                        <div className={`newCard__inner__content__time row-start-19 row-end-23 col-start-1 col-end-25 text-black px-4 flex justify-between`}>
                            <div onClick={() => {dispatch(setLearnOffCanvasIsActive()); dispatch(setActiveLearn(payload))}} className="newCard__inner__content__time__timeBlock flex gap-2 items-center cursor-pointer">
                                <i className="ri-lightbulb-line text-2xl text-dark-pink "></i>
                                <div className={`text-black text-sm font-semibold`}>Watch now</div>
                            </div>
                            <i onClick={() => {dispatch(setLearnOffCanvasIsActive()); dispatch(setActiveLearn(payload))}} className="ri-arrow-right-line text-2xl text-gold-accent cursor-pointer"></i>

                        </div>
                        <div className={`newCard__inner__content__accent row-start-24 row-end-25 col-start-1 col-end-25 bg-gold-accent rounded-b-lg pt-2`}></div>
                    </>
                    }

                </div>
            </div>
        </div>
    );
}
